import React from "react";

function SquareEarring() {
  return (
    <>
      <path
        className="earring"
        d="m 173.00983,303.47828 -28.31904,-28.31903 a 0.79476,0.79476 0 0 0 -0.13703,-0.11876 v 0 a 1.4616277,1.4616277 0 0 0 -0.24667,-0.22839 v 0 a 6.1845119,6.1845119 0 0 0 -8.30386,0.37455 l -7.59132,7.59132 -20.81906,20.70031 a 6.1662415,6.1662415 0 0 0 0,8.71495 l 6.02009,6.02009 22.33549,22.3355 a 6.1022952,6.1022952 0 0 0 4.34833,1.82703 6.1753766,6.1753766 0 0 0 4.36662,-1.82703 l 12.08584,-12.09497 v 0 0 l 16.23321,-16.23321 a 6.1662415,6.1662415 0 0 0 0.0273,-8.74236 z m -22.17107,13.46524 v 0 l -10.542,10.53286 -16.86353,-16.87267 -2.74055,-2.74056 19.18388,-19.23866 0.40193,-0.40195 19.64062,19.64061 z"
      />
      <path
        className="earring"
        d="m 409.38243,303.47828 -18.96464,-18.96463 -9.38182,-9.38182 a 7.207651,7.207651 0 0 0 -0.91352,-0.76736 v 0 a 6.0840248,6.0840248 0 0 0 -3.41657,-1.02312 v 0 a 6.1388359,6.1388359 0 0 0 -4.34833,1.82703 l -12.17718,12.1041 -16.21493,16.2058 a 6.1662415,6.1662415 0 0 0 0,8.71495 l 28.31902,28.31903 a 6.1571062,6.1571062 0 0 0 8.71495,0 l 25.0304,-25.03951 3.31607,-3.31605 a 6.1662415,6.1662415 0 0 0 0.0364,-8.67842 z m -32.71308,23.9981 -7.76488,-7.76491 -11.87573,-11.87572 14.75329,-14.76243 4.06515,-4.0743 0.80392,-0.80387 0.80389,0.80387 18.82759,18.83673 z"
      />
    </>
  );
}

export default SquareEarring;
